module.exports = __webpack_public_path__ + "static/media/Italy-night.0e878ed9.svg";